import React from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Divider, Typography } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as mdt from '../../../../common/modaltypes'
import { focusElemnt } from '../../../../common/helper'

const ConfirmModal = ({ updateModal }) => {
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  return (
    <Modal
      headTxt={'Confirm'}
      width={'35%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Box sx={{ padding: '10px 15px' }}>
        <Typography variant="h6" sx={{ fontWeight: '500', color: '#444', fontSize: '16px', paddingTop: '5px', paddingBottom: '10px' }}>
          Charges Updated for Selected Consignment Type !!!
        </Typography>

        <Box className="disabled-wrapper" sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp, height: '40px' }}
            className="btn btn-primary"
            onClick={() => {
              updateModal(false, mdt.deliveryChrgConfModal)
              focusElemnt('Select_Consignment_Type')
            }}
          >
            Ok
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default ConfirmModal
